import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { Accordion } from "../UIComponent/Accordion";

const faqData = [
  {
    sectionIndex: "1",
    title: "General Platform Questions",
    faqs: [
      {
        question: "What is Pepli?",
        answer:
          "Pepli is a digital platform designed exclusively for artists, performers, and creatives. It’s a community-driven space for booking gigs, networking, collaborating across disciplines, and building an audience without the distractions of traditional social media.",
      },
      {
        question:
          "How is Pepli different from other platforms like Instagram, Backstage, or LinkedIn?",
        answer: `Pepli is built by an artist, for artists. Unlike traditional platforms that prioritize algorithms and ads, Pepli focuses on authentic connections, creative growth, and financial opportunity:
        - Booking Tools like Backstage—but with community features.
        - Networking like LinkedIn—but designed for artists and performers.
        - Audience Building like Instagram—but without the pressure of likes and algorithms.`,
      },
      {
        question: "Who is Pepli for?",
        answer: `Pepli is for ALL artists, performers, and creatives, including:
        - Actors
        - Musicians
        - Vocalists
        - Dancers
        - Visual Artists
        - Writers
        - Filmmakers
        - Comics
        - Production Professionals
        - Talent Reps
        - Creatives working on stage, off stage, on camera & behind the camera.
        - Emerging and established creatives looking to connect, collaborate, and thrive.
        Employers, casting directors, agencies, and fans can also join to discover talent and engage with the creative community.`,
      },
      {
        question: "Is Pepli free to join?",
        answer:
          "Yes, joining Pepli is free. You can create a profile, connect with other artists, and explore the community. Paid plans unlock additional features like job listings, priority visibility, and more.",
      },
      {
        question: "Why Choose Pepli?",
        answer: `**1. Exceptional Quality**\nPepli is simple to use but does not compromise on quality. Our platform is built to help you focus on what matters most—your creativity.\n\n**2. Expertise and Knowledge**\nOur team understands the challenges artists face, and we’ve designed Pepli to address those needs, making it the ultimate tool for creatives.\n\n**3. User-friendly Experience**\nDesigned to be intuitive and easy to navigate, Pepli delivers a user-friendly, efficient app designed to make networking, collaboration, and audience-building seamless and effective.\n\n**4. The Same Expertise You’d Expect**\nJust like how Pepli brings exceptional knowledge to the creative community, we’ve spent hundreds of hours refining the platform to ensure it meets the real-world needs of artists, performers, and creatives.\n\n**5. Get Started & Live Creatively**\nSet up your profile, upload your portfolio, and connect with the community—all at no extra cost.`,
      },
      {
        question: "What benefits do I receive by verifying my identity on the app?",
        answer: "When you verify your identity on Pepli, you enhance your visibility and credibility. This process also opens the door in allowing you to send \"Membership(s) & Affiliations\" verification requests to organizations, businesses, unions, and schools that you are associated with. These verifications add an extra layer of credibility to your profile, increasing your overall platform visibility, & qualifying you for a subscription discount.",
      },
      {
        question: "How do I verify my identity on Pepli?",
        answer: "Go to your Profile ➡️ Tap on the word \"Verify\" on the top right below the edit pen ➡️ Tap on \"Proceed\" to be redirected to the Identity Verification page ➡️ Follow the prompts to begin verifying (takes just a few minutes) until you're done. As soon as your identity verification is approved you will receive a yellow badge to confirm your verified identity. You will also then be qualified to send membership & affiliation verification requests to organizations, businesses & schools/training facilities where you are affiliated.",
      },
      {
        question: "What is a \"Membership(s) & Affiliations\" request?",
        answer: "A \"Membership(s) & Affiliations\" request is another layer of verification where all the businesses, organizations, unions & school/training facilities you are associated with can be verified in Pepli that will then unlock more features, increase your visibility as well as opportunities. On top of all that a discount applies if you choose to get a subscription. For example, if you are a union member, you can go to \"Membership(s) & Affiliations,\" in your Profile, select the union you are a current, active member of & fill out the information that applies to you then submit. \nOnce that union receives & accepts your request as a verified member of their union, you will then receive a turquoise checkmark along with the benefits that apply. For example, you (or your reps on behalf of you) will be able to search & find listings that are only open to union members, etc. This also applies if you are a member of an organization, affiliated with a business as staff or otherwise, including if you are a student/professor/coach/alumni, etc., of a school/training facility. Having your \"Membership(s) & Affiliations\" section up to date in your profile helps to customize your creative experience on Pepli in a more targeted way."
      },
      {
        question: "What if I can't find the business, organization or school/training facility that I am associated with in \"Membership(s) & Affiliations\" nor anywhere on Pepli?",
        answer: "From the \"Membership(s) & Affiliations\" section in your Profile, you can tap on \"Send Request\" below the search field after a notification in red comes up about not seeing your organization listed.\n\nAnother way is that you can go to your Profile ➡️ tap on Settings icon on the top right ➡️ tap on Share Feedback from the list ➡️ Select the Category \"Business/Organization request.\" Type in the Subject then in the Description box type the name of the entity & their category (for example, a business, union, organization or school/training facility,) location, contact info & any notes. Then submit."
      },
      {
        question: "How do organizations, businesses, and schools benefit from verifying their identity on the app?",
        answer: "By verifying the identity of your organization, business, or school, it reinforces legitimacy and increases your visibility on our platform. This also enables your business/organization/school to receive membership and affiliation verification requests from your members, staff, alumni, students, and other people associated with your entity. Such verifications not only enhance your entity's visibility but also improve the trust and engagement levels with your audience."
      },
      {
        question: "How do \"Membership(s) and Affiliations\" verifications work between Businesses/Organizations/Schools and Artists/Performers/Creatives?",
        answer: "When businesses, organizations, and schools approve membership and affiliation verification requests from individuals who are associated with them, these now verified artists/performers/creatives receive a discount on their subscriptions as well as increased visibility of their creative work. It can also unlock additional features where the entity & artists are able to collaborate on the platform towards a shared goal. Additionally, it offers businesses, organizations & schools/training facilities the chance to attract more opportunities as it increases engagement, visibility and trust."
      },
      {
        question: "Can businesses, organizations, and schools verify affiliations with other entities on the app?",
        answer: "Yes, they can! Organizations, businesses, and schools can have their memberships and affiliations verified with other entities on Pepli. This verification extends your network, allowing people to interact more with all of your products and services, fostering stronger community engagement and collaboration."
      },
      {
        question: "I don't want others to see I'm looking at their profile. Can I navigate Pepli anonymously when I prefer & at other times allow it to be seen that I did check out someone's profile?",
        answer: "Yes & yes. You can see who visited your profile as well as profiles you've visited (private to you) in Analytics. If you want to control when others can see that you've looked at their profile or be seen as anonymous just go to your Profile ➡️ Tap on Settings icon on the upper-right corner ➡️ Select \"Profile Visibility\" ➡️ Tap on \"Profile Viewing Options\" & select how you want others to see you when you visit their profile."
      },
      {
        question: "Am I able to add Clients in Pepli?",
        answer: "Yes, you can add clients from your Profile in the Clients section. Just add & if the person accepts they are your client then they will show up in your Clients list. You can select to have your Clients list visible or hidden."
      },
      {
        question: "If I'm a talent rep or talent agency/management company can I submit my clients for work?",
        answer: "If you are a talent agent or manager, you can submit your clients for job listings & casting calls/auditions. In order to submit your clients for work as a Talent Rep, the talent has to accept your Client request, your profession on your profile has to state that you are a talent agent or manager & you have to be verified as a Talent Rep by a verified Talent Rep agency or management company through \"Membership(s) & Affiliations.\"\n\nVerified talent agencies & management companies can submit their clients for job listings & casting calls/auditions."
      },
      {
        question: "What features are in Pepli?",
        answer: "Features in Pepli include:\n\n● Your Profile\n● Add & view posts\n● React, comment & reply to posts\n● Bookmark posts\n● Join or create a Group\n● Add/view Stories\n● Send/receive messages\n● Search feature\n● Receive endorsements with others vouching for your skills, talent & work\n● Endorse/vouch for others on their skills, talent & work\n● Client list\n● Set & receive Appointments\n● Apply to casting calls/auditions & job listings / booking site\n● Talent Reps able to submit Clients for work\n● Register for events\n● Register for classes/workshops\n● Find Reps looking for Talent & Talent looking for Reps (Talent Scout)\n● Collaborate with peers across mediums\n● Share about fundraisers, projects, podcasts & more!"
      },
      {
        question: "What is Collaboration Opportunities?",
        answer: "Collaboration Opportunities is a list of individual artists, performers & creatives who have set their Collaboration Preferences in Settings to have others more easily find them through certain criteria like being open to mentorship or willing to trade/barter products or services, etc. You can select your Collaboration Preferences by going to Settings. To find Collaboration Opportunities go to ➡️ Listings ➡️ Collaboration Opportunities. You can use the Search bar to find individuals who are aligned with what you're looking for & vice versa."
      }
    ],
  },
  {
    sectionIndex: "2",
    title: "Artists & Creatives",
    faqs: [
      {
        question: "How can Pepli help me find gigs and work opportunities?",
        answer: `Pepli features a dedicated job board with casting calls/auditions, job interviews, and gig opportunities.
        - You can apply directly through the platform and set notifications for opportunities that match your skill set.
        - Premium members receive priority access to top gigs and custom job recommendations.`,
      },
      {
        question: "How do I collaborate with other artists on Pepli?",
        answer: `Pepli is designed to spark cross-medium collaboration.
        - Join community groups based on your discipline or interests.
        - Post collaboration opportunities to find musicians, actors, or creatives for your project.
        - Message other members to explore partnerships.`,
      },
      {
        question: "Can I showcase my work on Pepli?",
        answer: `Yes!
        - Upload videos, photos, and project samples to your profile.
        - Tag collaborators to highlight joint projects.
        - Create a professional portfolio that evolves as your career grows.`,
      },
      {
        question: "How can I find talent on Pepli?",
        answer: `-Search by skill, location, and availability using our advanced filters.
        - Post casting calls / auditions, and job listings.
        -  View verified profiles with media samples to discover top-tier talent quickly.`,
      },
      {
        question: "Is it free to post jobs on Pepli?",
        answer:
          "Basic listings are free, but you can upgrade to Sponsored Job Listings for priority placement and increased visibility.",
      },
      {
        question: "How does Pepli verify artists?",
        answer:
          "Artists can verify their identity when signing up. They can also receive a verified check mark on their profiles through organization and union membership (e.g., SAG-AFTRA, WGA, DGA, IATSE, etc.) including industry credentials. Verified profiles receive priority visibility in search results.",
      },
    ],
  },
  {
    sectionIndex: "3",
    title: "Fans & Supporters",
    faqs: [
      {
        question: "Can I follow my favorite artists?",
        answer: `Yes!
        - Create a fan profile and follow your favorite artists to see their work and updates.
        - Attend virtual or live artist showcases found through Pepli.`,
      },
      {
        question: "Can fans message artists?",
        answer: `Messaging is optional and controlled by the artist.
        - Artists can choose to receive messages from fans or restrict communication to professional contacts.
        - Respecting artist boundaries is a core value of Pepli.`,
      },
    ],
  },
  {
    sectionIndex: "4",
    title: "Membership & Pricing",
    faqs: [
      {
        question: "What are Pepli’s membership options?",
        answer: `Membership Tier Monthly Price Key Features

        **For Union & Organization Members or Creatives with industry Credentials (Affiliated Members):**
        - Free: $0 - Basic profile, limited job visibility, networking, messaging
        - Pro: $7.99/mo - Full job board access, full access messaging, increased visibility, Featured listings, priority search.

        **For Non-Union individuals (not affiliated with any union, organization or business in the arts & entertainment industry):**
        - Free: $0 - Basic profile, limited job visibility, networking, messaging
        - Premium: $9.99/mo - Full job board access, full access messaging, Featured listings, priority search.`,
      },
      {
        question: "Can I cancel my subscription anytime?",
        answer: `Yes, you can cancel your subscription anytime through your account settings. Your profile will remain active on the free tier.`,
      },
      {
        question: "How do I get a discount on my subscription or send a \"Membership(s) & Affiliations\" request to a business/organization/school that I am affiliated with?",
        answer: "Once you have verified your identity in Pepli first then you are qualified to send a \"Membership(s) & Affiliations\" request to businesses, organizations and schools/training facilities. To send a \"Membership(s) & Affiliations\" request:\n\nGo to your Profile ➡️ Scroll down a bit past the \"About\" section ➡️ stop at \"Membership(s) & Affiliations\" & tap on the (+) sign ➡️ Tap (+ Add) to then select the organization, union, business, or school/training facility where you are either a member, staff, student, alumni, professor, coach, talent rep, employer/hirer, etc., & fill out the information that applies to you then submit. You can also attach your member ID card. As soon as the business, organization or school verifies your membership/affiliation you will receive a turquoise verification checkmark. The entity you are affiliated with will show as verified on your profile and your discount will apply the following billing period if you have a subscription."
      },
    ],
  },
  {
    sectionIndex: "5",
    title: "Getting Started",
    faqs: [
      {
        question: "How do I sign up?",
        answer: `- Visit www.pepliapp.com
        - Download the Pepli app on your Android or iPhone (which can be found in Google Play & App Stores.)
        - Select whether you are a(n) Artist/Performer/Creative, Organization/Business/School, or Audience Member/Fan.
        - Create your profile and start connecting with the community.`,
      },
      {
        question:
          "What is a Union Member, Affiliate Member, Non-Union Individual, Organization / Business & Fan?",
        answer: `- Union Member - an active member of a union that is connected to the arts & entertainment industry (e.g., SAG-AFTRA, WGA, IATSE, etc.)
        - Affiliate Member - an active member of an organization that is connected to the arts & entertainment industry (e.g. PGA, WIF, AAFCA, etc.)
        - Non-Union Individual - an artist, performer, or creative involved (or just starting out) in the arts & entertainment industry with no union or organization membership nor affiliation.
        - Fan - Any individual who loves the arts and entertainment as well as wanting to stay connected to their favorite artists, performers & creative professionals. This includes being able to stay on top of General Public Events happening as far as shows, showings & all things entertainment.
        - Organization / Business / School - Any Organization, Business, or School involved in the Arts & Entertainment Industry.`,
      },
      {
        question: "Is Pepli available internationally?",
        answer: `Yes, Pepli is designed for global artists and creatives. While it’s starting with a U.S. focus, international artists are welcome to join and contribute to this global creative hub.`,
      },
    ],
  },
  {
    sectionIndex: "6",
    title: "Safety & Community Standards",
    faqs: [
      {
        question: "How does Pepli ensure a positive environment for artists?",
        answer: `Pepli is committed to a harassment-free, supportive community.
        - Anti-bullying policies and content moderation tools protect artists.
        - Artists control who can comment on their work and who can contact them.
        - Verified profiles reduce spam and increase trust.`,
      },
      {
        question: "How do I report inappropriate content or behavior?",
        answer: `Use the “Report” button on any profile, job listing, or post.
        Our moderation team reviews all reports and takes action to uphold community standards.`,
      },
    ],
  },
  {
    sectionIndex: "7",
    title: "Business Partnerships & Advertising",
    faqs: [
      {
        question: "Can my company partner with Pepli?",
        answer: `Yes! We welcome partnerships with arts organizations, businesses, unions, and creative brands.
        - Sponsorship opportunities for events, workshops, and career development content are available.
        - Featured partnerships can help showcase your services to our creative community.`,
      },
      {
        question: "How can I advertise on Pepli?",
        answer: `Pepli offers targeted advertising options for brands, services, and productions relevant to the creative industry.
        - Sponsored gigs and highlighted profiles.
        - Event promotions and email sponsorships.
        Contact us at partnerships@pepliapp.com to learn more.`,
      },
    ],
  },
  {
    sectionIndex: "8",
    title: "Technical Support",
    faqs: [
      {
        question: "I’m having trouble with my profile. Who do I contact?",
        answer: `Email us at support@pepliapp.com for help with any technical issues.
        Our support team is available Monday-Friday, 9 AM – 6 PM PST. Please allow up to a few days for a response.`,
      },
      {
        question: "Is there a mobile app for Pepli?",
        answer: `The Pepli app is available for download on iOS and Android.`,
      },
    ],
  },
  {
    sectionIndex: "9",
    title: "Final Call to Action",
    faqs: [
      {
        question: "Have more questions?",
        answer: `Reach out to us anytime at Info@PepliApp.com .
        We’re here to help you thrive creatively!`,
      },
    ],
  },
];

const FAQSection = () => {
  const [openSection, setOpenSection] = useState(null);
  const [openIndex, setOpenIndex] = useState({});

  const toggleFAQ = (sectionIndex, faqIndex) => {
    setOpenIndex((prev) => ({
      ...prev,
      [sectionIndex]: prev[sectionIndex] === faqIndex ? null : faqIndex,
    }));
  };

  const toggleSection = (sectionIndex) => {
    setOpenSection((prev) => (prev === sectionIndex ? null : sectionIndex));
  };

  return (
    <section className="bg-white" id="faqs">
      <div className="container mx-auto pb-7 pt-10">
        <div className="font-bold text-[#30D5C8] mb-8 text-4xl text-center">
          Frequently Asked Questions
        </div>
        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <button
              className="w-full flex justify-between items-center p-6 bg-white text-gray-800 font-bold md:text-xl text-[15px] border-b"
              onClick={() => toggleSection(sectionIndex)}
            >
              <span>
                {section.sectionIndex}. {section.title}
              </span>
              {openSection === sectionIndex ? (
                <FiMinus className="text-gray-800" />
              ) : (
                <FiPlus className="text-gray-800" />
              )}
            </button>
            {openSection === sectionIndex && (
              <div>
                {section.faqs.map((faq, idx) => (
                  <Accordion
                    key={idx}
                    question={faq.question}
                    answer={faq.answer}
                    isOpen={openIndex[section.sectionIndex] === idx}
                    onClick={() => toggleFAQ(section.sectionIndex, idx)}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
